module.exports = __webpack_public_path__ + "assets/fonts/arrow-left.ffaddd37.svg";